import { getTimeOrigin, getUseServiceWorker } from '#pplx/frontend/metrics/browser.js';
import { datadogRum } from '@datadog/browser-rum';
import { useCallback, useMemo } from 'react';
const IGNORE_THRESHOLD = 30 * 1e3;
let fttvRecorded = false;
let ignoreMetrics = typeof document !== 'undefined' &&
    (document.hidden ||
        ('prerendering' in document && !!document.prerendering));
if (typeof document !== 'undefined') {
    const handleVisibilityChange = () => {
        ignoreMetrics ||= document.hidden;
        if (ignoreMetrics)
            document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    if ('prerendering' in document) {
        const handlePrerenderingChange = () => {
            ignoreMetrics ||= true;
        };
        document.addEventListener('prerenderingchange', handlePrerenderingChange, {
            once: true,
        });
    }
}
export const initializeMarkTTV = () => {
    // If since timeOrigin is greater than the ignore threshold, skip reporting.
    // On paper, this looks bad, but there are too many ways a tab/window can be
    // backgrounded, throttled, or otherwise not rendered immediately, most of
    // which cannot be detected in JavaScript--but we try to detect those, too.
    ignoreMetrics ||= performance.now() > IGNORE_THRESHOLD;
};
/**
 * Mark the time to interactive for the current session
 * @returns A function to mark the time to interactive
 */
export const useMarkTTV = () => {
    const markTTV = useCallback((startTimeFromTimeOrigin = 0) => {
        // If the pathname has changed, we don't want to mark
        // as we'd be measuring a session instead of page load
        let ttvMetric = 'ttv';
        // We're not doing `firstUrl === window.location.pathname` checking bc 1st page can be a redirect
        if (!fttvRecorded) {
            ttvMetric = 'fttv';
            fttvRecorded = true;
        }
        // Web Vitals approach: Only measure if page is currently visible
        // AND has never been backgrounded. This prevents artificially
        // inflated metrics from browser throttling.
        if (ignoreMetrics)
            return;
        performance.mark(ttvMetric);
        datadogRum.addDurationVital(ttvMetric, {
            startTime: getTimeOrigin() + startTimeFromTimeOrigin,
            duration: performance.now() - startTimeFromTimeOrigin,
            context: {
                useServiceWorker: getUseServiceWorker(),
            },
        });
    }, []);
    return useMemo(() => ({ markTTV }), [markTTV]);
};
//# sourceMappingURL=useMarkTTV.js.map